<template>
  <div class="section" id="profile-edit">
    <div class="title">プロフィール</div>
    <div class="columns">
      <div class="column">
        <PhotoPreview v-model="photoFile" :currentSrc="photoURL" />
        <NicknameTextField class="shorttextbox" v-model="nickname" />

        <b-field label="紹介文" message="※100文字以内、改行は反映されます">
          <b-input type="textarea" v-model="selfIntroduction" />
        </b-field>

        <b-field label="メールアドレス" v-if="email">
          <b-input type="text" v-model="email" disabled />
        </b-field>

        <h3 class="has-text-weight-bold mb-2">動画共通サムネイル登録</h3>
        <div class="thumbnail">
          <figure class="image thumbnail__image">
            <b-image :src="previewImageUrl" ratio="400by255" />
          </figure>
          <b-field label="">
            <b-upload @input="onFileChanged" drag-drop expanded>
              <div class="content has-text-centered preview__upload">
                <p>
                  <b-icon icon="upload" size="is-large"></b-icon>
                </p>
                <p>Drop your files here or click to upload</p>
              </div>
            </b-upload>
          </b-field>
        </div>

        <div class="buttonwrap has-text-centered">
          <b-button
            class="button"
            @click="submitForm"
            :loading="submitting"
          >
            更新する
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NicknameTextField from '@/components/Molecules/NicknameTextField';
import PhotoPreview from '@/components/Molecules/PhotoPreview';
import profileMixin from '@/mixins/profileMixin'

const DEAFULT_PHOTO_URL =
  'https://firebasestorage.googleapis.com/v0/b/pandora-988f8.appspot.com/o/all%2Fdefault-user-icon.png?alt=media&token=4a1a4307-1990-4c99-a944-9b8d289e1a50';

export default {
  name: 'CastProfile',
  mixins: [profileMixin],
  components: {
    NicknameTextField,
    PhotoPreview
  },
  data() {
    return {
      photoFile: null,
      photoURL: '',
      imageFile: null,
      previewImageUrl: null,
      selfIntroduction: '',
      submitting: false
    };
  },
  async created() {
    await this.loadProfile(this.$store.state.auth.uid);
  },
  computed: {
    isPerformer() {
      return this.userType === 'performer';
    },
    email() {
      return this.$store.state.auth.email;
    }
  },
  methods: {
    async loadProfile(uid) {
      let userId = uid;
      await this.$store.dispatch('user/loadUserDoc', userId);
      this.photoURL = this.$store.state.user.photoURL
        ? this.$store.state.user.photoURL
        : DEAFULT_PHOTO_URL;

      if (this.$store.state.user.thumbnailURL) {
        this.previewImageUrl = this.$store.state.user.thumbnailURL;
      }

      this.nickname = this.$store.state.user.nickname;
      this.selfIntroduction = this.$store.state.user.selfIntroduction;
    },
    async submitForm() {
      this.submitting = true;

      let validateResult = await this.validate();
      if (!validateResult) {
        this.submitting = false;
        return;
      }

      try {
        await this.$store.dispatch('updateUserProfile', {
          nickname: this.nickname,
          photoFile: this.photoFile,
          imageFile: this.imageFile,
          selfIntroduction: this.selfIntroduction
        });
        this.$buefy.toast.open({
          message: 'プロフィールがアップデートされました',
          type: 'is-success'
        });
      } catch (err) {
        console.error(err);
        this.$buefy.toast.open({
          message: 'プロフィールのアップデートが失敗しました',
          type: 'is-danger'
        });
      }
      this.submitting = false;
    },
    onFileChanged(inputFile) {
      this.imageFile = inputFile;
      this.previewImageUrl = URL.createObjectURL(inputFile);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/profile-edit.scss';

.floatable-preview {
  position: relative;
}

.floating-camera-icon {
  position: absolute;
  background-color: rgba(256, 256, 256, 0.75);
  border-radius: 50%;
  bottom: 8%;
  right: 8%;
  padding: 8%;
}
.floating-camera-icon:hover {
  cursor: pointer;
}
.field.has-addons .control:not(:last-child) {
  width: 100%;
}
.tags-display {
  margin-bottom: 10px;
}
</style>
